/* global jQuery */
import React, { Component } from 'react'
import dateFormat from '../../lib/utils/dateformat'
import debounce from '../../lib/utils/debounce'
import DatePickerV2 from './DatePickerV2.jsx'
import classNames from 'classnames'
const xLarge = 1280
const large = 1024
const medium = 768
const small = 412

class SliderItem extends Component {

  onItemSelected = () => {
    if (typeof this.props.onPressCallback !== undefined) {
      this.props.onPressCallback(this.props.iDate)
    }
  }
  render() {
    const {
      dateNo = '',
      dayName = '',
      month = '',
      year = '',
      isActive = false,
      isNow = false,
      type = 'day'
    } = this.props

    let liClass = [ 'DateCarousel__list__item' ]
    isActive ? liClass.push('is-active') : liClass.push('has-event')
    let liProps = {
      onClick: this.onItemSelected,
      className: classNames(liClass)
    }

    return (
      <li {...liProps}>
        {
          (type !== 'day') ? (
            <div className="DateCarousel__day" style={{ fontSize: 'inherit' }}>
              <span className="DateCarousel__dayNum"><span>{month}</span></span>
              <span className="DateCarousel__dayName" style={{ color: 'inherit' }}>{year}</span>
            </div>
          ) : (
              <div className="DateCarousel__day" style={{ fontSize: 'inherit' }}>
                <span className="DateCarousel__dayNum"><span>{isNow ? 'Now' : `${month} ${dateNo}`}</span></span>
                {
                  !isNow ? <span className="DateCarousel__dayName" style={{ color: 'inherit' }}>{dayName}</span> : null
                }
              </div>
            )
        }
      </li>
    )
  }
}

export default class DateSliderV2 extends Component {
  constructor(props) {
    super(props)
    let { device = {} } = props
    let screenWidth = 0
    let itemWidth = 80
    let dayRange = this.getSliderRange(screenWidth, device)
    let startPos = 0 - (itemWidth * dayRange)
    this.state = {
      activeDate: null,
      displayDate: null,
      oneDay: 86400000,  // 1 day in milliseconds
      dayRange: dayRange,
      itemWidth: itemWidth,
      touchObject: {
        startX: null,
        startY: null,
        curX: null,
        curY: null,
        swipeLength: null
      },
      didSwipe: false,
      dragging: false,
      animate: false,
      currentPos: startPos,
      touchSliderMove: startPos,
      device: device,
      screenWidth: screenWidth
    }
    //method bindings
    this.selectDate = this.selectDate.bind(this)
    this.previous = this.previous.bind(this)
    this.next = this.next.bind(this)
    this.swipeStart = this.swipeStart.bind(this)
    this.swipeMove = this.swipeMove.bind(this)
    this.swipeEnd = this.swipeEnd.bind(this)
    this._throttle = this._throttle.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  /**
  * Intial load so add the date to the state for use and manipulation
  * @returns {undefined} undefined
  **/
  componentWillMount() {
    let date = this.props.date
    let type = this.props.type
    if (!date) {
      date = new Date()
      date = date.toISOString()
    }
    let oDate = dateFormat.dateToObject(date) || new Date()
    let iDate = oDate.setHours(0, 0, 0, 0)
    if (type == 'month') {
      iDate = dateFormat.dateToObject(iDate).setDate(1)
    }
    this.setState({
      activeDate: iDate,
      displayDate: iDate
    })
  }


  /**
  * Reset state if date has changed
  *
  * @param {Object} nextProps Props
  * @returns {undefined} undefined
  **/
  componentWillReceiveProps(nextProps) {
    let oDate = dateFormat.dateToObject(nextProps.date) || new Date()
    let iDate = oDate.setHours(0, 0, 0, 0)
    let type = this.props.type
    let currDate = this.props.date || new Date()
    let iCurrDate = dateFormat.dateToObject(currDate).setHours(0, 0, 0, 0)
    if (type == 'month') {
      iDate = dateFormat.dateToObject(iDate).setDate(1)
      iCurrDate = dateFormat.dateToObject(iCurrDate).setDate(1)
    }
    if (iDate !== iCurrDate) {
      this.animateToDate(iDate)
      this.setState({
        activeDate: iDate,
        didSwipe: false
      })
    }
  }

  /**
  * After the component has drawn reset the position of the slider
  * this will cause the css animation to trigger. The timeout is to
  * force react to re-render else it trys to group the changes into 1
  * update and you won't see the animation
  *
  * @returns {undefined} undefined
  **/
  componentDidUpdate() {
    let iDayRange = this.state.dayRange
    let iItemWidth = this.state.itemWidth
    let iNewPos = 0 - (iDayRange * iItemWidth)

    if (iNewPos !== this.state.currentPos) {
      setTimeout(function () {
        this.setState({
          currentPos: iNewPos,
          touchSliderMove: iNewPos,
          animate: true
        })
      }.bind(this), 1)
    }
  }

  /**
   * After Component is mounted bind jquery resize event handlers to adjust slider based on screen size
   * This helps to handle touch devices orientation changes
   * @returns {undefined}
   */

  componentDidMount() {
    this.initResizeEvent()
  }

  /**
   * triggers resize handlers after a debounce of 500ms
   * @returns {undefined}
   */
  initResizeEvent() {
    try {
      jQuery(window).resize(debounce(this.handleResize, 500))
      this.handleResize()
    } catch (e) {
      /* Intentionally ignored error */
    }
  }
  /**
   * window resize handler, checks if current width and resized \
   * width is differe t and initialize the state accordingly
   * @return {undefined}
   */
  handleResize() {
    let currentWidth = jQuery(window).outerWidth()
    let screenWidth = this.state.screenWidth
    let device = this.state.device
    if (screenWidth !== currentWidth) {
      this.setState({
        screenWidth: currentWidth,
        dayRange: this.getSliderRange(currentWidth, device)
      })
    }
  }

  /**
  * Captures the date of the node clicked and sets the state to that. If
  * a swipe was tracked the click is ignored and the swipe tracker reset
  *
  * @param {Number} iDate date
  * @returns {undefined} undefined
  **/
  selectDate(iDate) {
    iDate = (typeof iDate === 'object') ? iDate.setHours(0, 0, 0, 0) : iDate
    if (typeof this.state.touchObject.swipeLength !== 'number' && this.props.enabled) {
      this.setState({
        activeDate: iDate
      })

      this.dateSelected(iDate)
      this.animateToDate(iDate)
    }
  }

  /**
  * Call once we have selected a date
  *
  * @param {Number} iDate date
  * @returns {undefined} undefined
  **/
  dateSelected(iDate) {
    let type = this.props.type || 'day'
    if (typeof this.props.callback == 'function') {
      let selectedDate = dateFormat.dateFormat(iDate, type == 'month' ? 'date19' : 'date12')
      this.props.callback(dateFormat.dateToObject(iDate), selectedDate)
    }
  }

  /**
  * Subtracts #(dayRange-1) days from the display date and then forces a redraw
  * @returns {undefined} undefined
  **/
  previous() {
    let iNewDate
    let iDisplayDate = this.state.displayDate
    let dayRange = this.state.dayRange
    if (this.props.type == 'month') {
      iNewDate = dateFormat.subtractMonths(iDisplayDate, dayRange - 1).setHours(0, 0, 0, 0)
    } else {
      iNewDate = iDisplayDate - (this.state.oneDay * (dayRange - 1))
    }
    this.animateToDate(iNewDate)
  }

  /**
  * Adds #(dayRange) days from the display date and then forces a redraw
  * @returns {undefined} undefined
  **/
  next() {
    let iNewDate
    let iDisplayDate = this.state.displayDate
    let dayRange = this.state.dayRange
    if (this.props.type == 'month') {
      iNewDate = dateFormat.addMonths(iDisplayDate, dayRange - 1).setHours(0, 0, 0, 0)
    } else {
      iNewDate = iDisplayDate + (this.state.oneDay * (dayRange - 1))
    }
    this.animateToDate(iNewDate)
  }

  /**
  * Redraws the page to last know good state
  * @returns {undefined} undefined
  **/
  reset() {
    this.setState({})
  }

  animateToDate(newDate) {
    let displayDate = this.state.displayDate
    let type = this.props.type
    let dayRange = this.state.dayRange
    let minDate
    let maxDate
    let itemWidth = this.state.itemWidth
    let diff = 0
    let moveTo = 0
    let oneDay = this.state.oneDay
    if (type == 'month') {
      minDate = dateFormat.subtractMonths(newDate, dayRange).setHours(0, 0, 0, 0)
      maxDate = dateFormat.addMonths(newDate, dayRange * 3).setHours(0, 0, 0, 0)
    } else {
      minDate = newDate - (oneDay * dayRange)
      maxDate = minDate + ((dayRange * 3) * oneDay)
    }
    if (displayDate >= minDate && displayDate <= maxDate) {
      // is the original date within the visible range?
      if (type == 'month') {
        diff = dateFormat.dateDiff(minDate, displayDate, 'months')
      } else {
        diff = (displayDate - minDate) / oneDay
      }
      moveTo = 0 - diff * itemWidth
    } else if (displayDate > maxDate) {
      // is it bigger then set moveto to last
      moveTo = 0 - (itemWidth * (dayRange * 3))
    } else if (displayDate < minDate) {
      // is it smaller then set moveto to first
      moveTo = 0
    }
    
    this.setState({
      displayDate: newDate,
      currentPos: moveTo,
      touchSliderMove: moveTo,
      animate: false
    })
  }
  getSliderRange(screenWidth = 0, device = {}) {
    let dayRange = 9
    let wi = screenWidth
    if (screenWidth > 0) {
      dayRange = (wi >= xLarge ? 9 :
        wi >= large ? 7 :
          wi >= medium ? 7 :
            wi >= small ? 5 : 3)
    }
    else {
      dayRange = (device.desktop ? 9 :
        device.tablet ? 9 :
          device.mobile ? 5 : 3)
    }
    return dayRange
  }
  /**
  * Capture the start position of the mouse/touch so that we can
  * determine the direction and size of the interaction later.
  *
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  swipeStart(e) {
    let posX, posY
    posX = (e.touches !== undefined) ? e.touches[0].pageX : e.clientX
    posY = (e.touches !== undefined) ? e.touches[0].pageY : e.clientY
    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    })
  }

  /**
  * Captures the current mouse/finger movement and stores the value to
  * allow the position of the slider to be updated.
  *
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  swipeMove(e) {
    if (!this.state.dragging) {
      return
    }

    let touchObject = this.state.touchObject
    let iCurrX = (e.touches) ? e.touches[0].pageX : e.clientX
    touchObject.curY = (e.touches) ? e.touches[0].pageY : e.clientY
    touchObject.swipeLength = touchObject.curX - touchObject.startX
    touchObject.curX = iCurrX
    let touchSlider = {
      touchObject: touchObject
    }
    let swipeMoved = null
    let swipeDirection = this.swipeDirection(touchObject)
    if (swipeDirection === 'left') {
      swipeMoved = this.state.currentPos + iCurrX
    } else if (swipeDirection === 'right') {
      swipeMoved = this.state.currentPos - iCurrX
    }
    touchSlider.touchSliderMove = swipeMoved
    this.setState(touchSlider)
  }

  /**
    * Capture end event and then calculate the action desired by the user
    *
    * @param {Object} e event object
    * @returns {undefined} undefined
    **/
  swipeEnd() {
    if (!this.state.dragging) {
      return
    }

    let touchObject = this.state.touchObject
    let swipeDirection = this.swipeDirection(touchObject)
    // reset the state of touch related state letiables.
    this.setState({
      dragging: false,
      touchObject: {},
      swipeLength: 0,
      touchSliderMove: this.state.currentPos
    })

    if (swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 5) {
      this.setState({ didSwipe: true })
      this.previous()
    } else if (swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 5) {
      this.setState({ didSwipe: true })
      this.next()
    } else if (Math.abs(touchObject.swipeLength) > 1) {
      // micro swipe, not really a click.
      this.reset()
    } else {
      this.reset()
    }

  }

  /**
  * Determines whether the swipe was within a certain angle range and
  * therefore a horizontal swipe rather than a verticle one.
  *
  * @param {Object} touchObject touchObject
  * @returns {String} left/right/vertical
  **/
  swipeDirection(touchObject) {

    let xDist = touchObject.startX - touchObject.curX
    let yDist = touchObject.startY - touchObject.curY
    let r = Math.atan2(yDist, xDist)
    let swipeAngle = Math.round(r * 180 / Math.PI)

    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle)
    }
    if ((swipeAngle <= 45) && (swipeAngle >= 0) || (swipeAngle <= 360) && (swipeAngle >= 315)) {
      return (this.props.rtl === false ? 'left' : 'right')
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return (this.props.rtl === false ? 'right' : 'left')
    }

    return 'vertical'
  }

  /**
  * for performance reasons provide a facility to throttle the updates
  * triggered by mousemove
  *
  * @param {Number} delay time to delay
  * @param {Function} callback function reference which needs to be throttled
  * @returns {Function} Anonymous Function
  **/
  _throttle(delay, callback) {
    let previousCall = new Date().getTime()
    return function () {
      let time = new Date().getTime()
      if ((time - previousCall) >= delay) {
        previousCall = time
        callback.apply(null, arguments)
      }
    }
  }
  render() {
    //let activeDates    = this.props.activeDates || {}
    let displayDate = this.state.displayDate
    let activeDate = this.state.activeDate
    let oneDay = this.state.oneDay
    let dayRange = this.state.dayRange
    let itemWidth = this.state.itemWidth
    let dayNames = dateFormat.dateDayNamesMedium()
    let monthNames = dateFormat.monthNamesShort()
    let dateNodes = []
    let startDate = displayDate - (oneDay * dayRange)
    let type = this.props.type
    let now = new Date()
    let oActiveDate = dateFormat.dateToObject(activeDate)
    if (type == 'month') {
      startDate = dateFormat.subtractMonths(displayDate, dayRange).setHours(0, 0, 0, 0)
    }
    // construct dayRange*3 no. of nodes for smooth scroll effect
    for (let i = 0; i < dayRange * 3; i++) {
      let iCurrDate
      let oCurrDate
      let isNow = false
      let isActive = false
      let currMonth
      let currYear
      if (type == 'month') {
        oCurrDate = dateFormat.addMonths(startDate, i)
        iCurrDate = oCurrDate.setHours(0, 0, 0, 0)
        currMonth = oCurrDate.getMonth()
        currYear = oCurrDate.getFullYear()
        isNow = (now.getMonth() == currMonth) && (now.getFullYear() == currYear)
        isActive = (oActiveDate.getMonth() == currMonth) && (oActiveDate.getFullYear() == currYear)
      } else {
        iCurrDate = startDate + (oneDay * i)
        oCurrDate = dateFormat.dateToObject(iCurrDate)
        currMonth = oCurrDate.getMonth()
        currYear = oCurrDate.getFullYear()
        isActive = (activeDate == iCurrDate)
        isNow = (now.setHours(0, 0, 0, 0) == iCurrDate)
      }
      let dateItemProps = {
        dateNo: oCurrDate.getDate(),
        dayName: dayNames[oCurrDate.getDay()],
        month: monthNames[currMonth],
        year: currYear,
        isActive: isActive,
        isNow: isNow,
        iDate: iCurrDate
      }
      dateNodes.push(
        <SliderItem
          {...dateItemProps}
          onPressCallback={this.selectDate}
          key={iCurrDate}
          type={type}
        />
      )
    }

    let sliderProps = {
      onMouseDown: this.swipeStart,
      onMouseMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
      onMouseUp: this.swipeEnd,
      onMouseLeave: this.state.dragging ? this.swipeEnd : null,
      onTouchStart: this.swipeStart,
      onTouchMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
      onTouchEnd: this.swipeEnd,
      onTouchCancel: this.state.dragging ? this.swipeEnd : null
    }
    let sliderStyle = {
      width: itemWidth * dayRange * 3 + 'px',
      left: (-(40) + this.state.touchSliderMove + (itemWidth * dayRange / 2)) + 'px',
      overflowY: 'initial'
    }
    if (this.state.animate) {
      sliderStyle.transition = 'left 1s' //'all 1s ease-in-out'
    }
    return (
      <div className="DatePicker DatePicker--cricket" >
        <div className="DateCarousel" { ...sliderProps } style={{ overflow: 'hidden', msOverflowStyle:'none' }}>
          <button className="carousel__arrow carousel__arrow--left" onClick={this.previous}></button>
          <ul className="DateCarousel__list" style={sliderStyle}>
            {dateNodes}
          </ul>
          <button className="carousel__arrow carousel__arrow--right" onClick={this.next}></button>
        </div>
        <DatePickerV2 date={displayDate} activeDate = { activeDate } callback={this.selectDate} type={type} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../app/components/common/DateSliderV2.jsx